export default (function (_ref) {
    var store = _ref.store,
        redirect = _ref.redirect;

    if (store.$readAuthCookie()) redirect('/dashboard');
});


//////////////////
// WEBPACK FOOTER
// ./src/middleware/check-auth.js
// module id = ./src/middleware/check-auth.js
// module chunks = 34